module.exports = __webpack_public_path__ + "img/ZJ5305.32c1ac82.png";